import React, { useState } from 'react'; 
import GetSelectMonths from '../../Dropdowns/getSelectMonth';
import GetSelectYears from '../../Dropdowns/getSelectYear';
import GetCommodities from '../../Dropdowns/getCommodities';
import Scheme_Sale_Dist from './Scheme_Sale_Dist';

const Scheme_Sale_Interface = ({ heading }) => {

    const [renderContent, setRenderContent] = useState(null);
    const [loading, setLoading] = useState(true);  

    const handleLoadingChange = (isLoading) => {
       setLoading(isLoading);
   };

        const handleSubmit = () => {
        const month = document.getElementById('month').value;
        const year = document.getElementById('year').value;
        const allot_month = document.getElementById('allot_month').value;
        const allot_year = document.getElementById('allot_year').value;
        const comm_id = document.getElementById('comm_id').value; 
 
        if (month==0 || month == null || month ==''  ) { 
            alert('Please select Distribution Month');
        } else  if (year==0 || year == null || year ==''  ) {
            alert('Please select Distribution Year');
        }else  if (allot_month==0 || allot_month == null || allot_month ==''  ) { 
            alert('Please select Allotted Month');
        } else  if (allot_year==0 || allot_year == null || allot_year ==''  ) { 
            alert('Please select Allotted Year');
        } else  if (comm_id==0 || comm_id == null || comm_id ==''  ) {
            alert('Please select Commodity');
        }  else {
            setRenderContent(null);

            setTimeout(() => {
                setRenderContent(
                    <Scheme_Sale_Dist 
                        month={month} 
                        year={year}
                        allot_month={allot_month} 
                        allot_year={allot_year}  
                        comm_id={comm_id} 
                        heading={heading} 
                    />
                );
            }, 0);
                }
    };

    return (
        <>
            <div className="wrapper row3">
                <div id="container">
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <table width="30%">
                            <thead>
                                <tr className="tableheader">
                                    <th colSpan={10}>{heading}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>Distribution<br/>Month</td>
                                    <td><GetSelectMonths input_id = {"month"} onLoadingChange={handleLoadingChange} /></td>
                                    <td>Distribution<br/>Year</td>
                                    <td><GetSelectYears input_id = 'year' onLoadingChange={handleLoadingChange} /></td>

                                    <td>Allotted<br/>Month</td>
                                    <td><GetSelectMonths input_id = 'allot_month' onLoadingChange={handleLoadingChange} /></td>
                                    <td>Allotted<br/>Year</td>
                                    <td><GetSelectYears input_id = 'allot_year' onLoadingChange={handleLoadingChange} /></td>

                                  <td>Commodity</td>
                                    <td><GetCommodities /></td>
                                </tr>
                                <tr>
                                    <td colSpan={10} align="center">
                                    <button onClick={handleSubmit} className="button button2" disabled={loading}>
                                            Submit
                                        </button>
                                        <button className="button button2">
                                            Back
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <div id="loading" style={{ display: 'none', textAlign: 'center' }}>
                        <img src="images/progress.gif" alt="Loading" />
                    </div>
                    <br />
                    {/* Render the dynamic content here */}
                    <div id="detailsER">{renderContent}</div>
                </div>
            </div>
        </>
    );
};

export default Scheme_Sale_Interface;
